import React, { useEffect, useState } from "react";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables.js";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link } from "react-router-dom";

const dynamicData = [
  {
    invoice: "526534",
    name: "Kathryn Murphy",
    userImage: "assets/images/user-list/user-list1.png",
    issuedDate: "25 Jan 2024",
    amount: "$200.00",
    status: "Paid",
  },
  {
    invoice: "696589",
    name: "Annette Black",
    userImage: "assets/images/user-list/user-list2.png",
    issuedDate: "25 Jan 2024",
    amount: "$200.00",
    status: "Paid",
  },
  {
    invoice: "256584",
    name: "Ronald Richards",
    userImage: "assets/images/user-list/user-list3.png",
    issuedDate: "10 Feb 2024",
    amount: "$200.00",
    status: "Paid",
  },
  // Add more data here
];

const TableDataLayer = () => {
  useEffect(() => {
    const table = $("#dataTable").DataTable({
      pageLength: 10,
    });
    return () => {
      table.destroy(true);
    };
  }, [dynamicData]);

  return (
    <div className="col-xxl-9 col-xl-6 col-lg-12">
      <div className="card basic-data-table">
        <div className="card-header">
          <h5 className="card-title mb-0">Dynamic Data Tables</h5>
        </div>
        <div className="card-body">
          <div className="table-responsive scroll-sm overflow-sm">
            <table
              className="table bordered-table mb-0"
              id="dataTable"
              data-page-length={10}
            >
              <thead>
                <tr>
                  <th scope="col">
                    <div className="form-check style-check d-flex align-items-center">
                      <input className="form-check-input" type="checkbox" />
                      <label className="form-check-label">S.L</label>
                    </div>
                  </th>
                  <th scope="col">Invoice</th>
                  <th scope="col">Name</th>
                  <th scope="col">Issued Date</th>
                  <th scope="col">Amount</th>
                  <th scope="col">Status</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                {dynamicData.map((item, index) => (
                  <tr key={item.invoice}>
                    <td>
                      <div className="form-check style-check d-flex align-items-center">
                        <input className="form-check-input" type="checkbox" />
                        <label className="form-check-label">{index + 1}</label>
                      </div>
                    </td>
                    <td>
                      <Link to="#" className="text-primary-600">
                        #{item.invoice}
                      </Link>
                    </td>
                    <td>
                      <div className="d-flex align-items-center">
                        <img
                          src={item.userImage}
                          alt=""
                          className="flex-shrink-0 me-12 radius-8"
                        />
                        <h6 className="text-md mb-0 fw-medium flex-grow-1">
                          {item.name}
                        </h6>
                      </div>
                    </td>
                    <td>{item.issuedDate}</td>
                    <td>{item.amount}</td>
                    <td>
                      <span
                        className={`bg-${
                          item.status === "Paid" ? "success" : "warning"
                        }-focus text-${
                          item.status === "Paid" ? "success" : "warning"
                        }-main px-24 py-4 rounded-pill fw-medium text-sm`}
                      >
                        {item.status}
                      </span>
                    </td>
                    <td>
                      <Link
                        to="#"
                        className="w-32-px h-32-px me-8 bg-primary-light text-primary-600 rounded-circle d-inline-flex align-items-center justify-content-center"
                      >
                        <Icon icon="iconamoon:eye-light" />
                      </Link>
                      <Link
                        to="#"
                        className="w-32-px h-32-px me-8 bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
                      >
                        <Icon icon="lucide:edit" />
                      </Link>
                      <Link
                        to="#"
                        className="w-32-px h-32-px me-8 bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
                      >
                        <Icon icon="mingcute:delete-2-line" />
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableDataLayer;
